import { ServiceRunsTable } from '@/components/services/detail/ServiceRunsTable';

interface EndpointHistoryTabProps {
  endpointId: string;
  onSwitchToTest?: () => void;
}

/**
 * The Advanced endpoint hub's Runs tab: the same runs table as the AI Service
 * page's Runs tab (task 1306), so there is one runs list and one run page.
 */
export function EndpointHistoryTab({ endpointId, onSwitchToTest }: EndpointHistoryTabProps) {
  return <ServiceRunsTable endpointId={endpointId} onSwitchToTest={onSwitchToTest} />;
}
